import axios from 'axios'

export function searchVismaCustomers(integrationId, searchTerm) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/integrations/' + integrationId + '/-actions/fetch-customers-visma?keyword=' + searchTerm, {
        headers: {
            'Content-Type': 'application/vnd.api+json',
        },
    })
}
export function createVismaCustomer(integrationId, data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/integrations/' + integrationId + '/-actions/create-customer-visma', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json',
        },
    })
}
export function authorizeVisma(integrationId) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/integrations/' + integrationId + '/-actions/authorize-visma', {
        headers: {
            'Content-Type': 'application/vnd.api+json',
        },
    })
}

export function setVismaAuthToken(integrationId, code) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/integrations/' + integrationId + '/-actions/visma-authenticate?code=' + code, {
        headers: {
            'Content-Type': 'application/vnd.api+json',
        },
    })
}

export function getVismaIntegration(spaceId) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceId + '/integrations?filter[name]=visma', {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function searchVismaArticles(integrationId, searchTerm) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/integrations/' + integrationId + '/-actions/fetch-articles-visma?keyword=' + searchTerm, {
        headers: {
            'Content-Type': 'application/vnd.api+json',
        },
    })
}